export interface BlogListItem {
  id: number;
  image: string;
  date: string; // ISO string yyyy-mm-dd
  category: string;
}

export const blogList: BlogListItem[] = [
  { id: 1, image: '/images/news/blog-6.jpeg', date: '2025-12-20', category: 'News' },
  { id: 2, image: '/images/news/blog-1.jpg',  date: '2024-01-15', category: 'News' },
  { id: 3, image: '/images/news/blog-2.jpg',  date: '2024-01-10', category: 'News' },
  { id: 4, image: '/images/news/blog-3.jpg',  date: '2025-05-20', category: 'News' },
  { id: 5, image: '/images/news/blog-4.jpg',  date: '2025-06-28', category: 'News' },
  { id: 6, image: '/images/news/blog-5.jpg',  date: '2025-08-28', category: 'News' },
  { id: 7, image: '/images/news/blog-7.jpg',  date: '2026-01-10', category: 'News' },
  { id: 8, image: '/images/blog/jasmin/jasmin-1.jpeg', date: '2026-06-28', category: 'News' }
];

export default blogList;
